import React from 'react';
import { Icon } from '@iconify/react';
function Hero() {
	return (
		<section className="[@media(orientation:landscape)]:min-h-screen flex flex-col justify-center relative bg-primary px-4 py-8 md:text-center [&>*]:transition-all [&>*]:duration-300 [&>*]:ease-linear">
			<div className="py-8 md:py-16">
				<div className="md:mx-auto max-w-md md:max-w-2xl w-full">
					<p className="text-3xl sm:text-4xl lg:text-5xl font-bold py-2 text-blue-200 ">
						Hello, I am
					</p>
					<h1 className="text-white font-bold text-4xl md:text-5xl lg:text-7xl lg:py-2">
						Kimboh Lovette
					</h1>
					<p className="text-slate-200 font-semibold text-xl my-4 lg:pb-2">
						Full Stack Developer
					</p>
					<div className="text-lg font-light text-slate-200 lg:text-xl">
						<p>
							I build modern applications with state-of-the-art
							technologies.
						</p>
						{/* <span className="md:block">I love Tailwind CSS</span> */}
					</div>
				</div>
				<div className="flex flex-row md:justify-center sm:items-center w-full mt-8 gap-5">
					<a href="#contacts">
						<div className="py-2 px-5 bg-blue-200 rounded-md text-primary font-medium w-full max-w-[200px]">
							<Icon
								icon="fluent:call-24-filled"
								className="text-2xl sm:hidden"
							/>
							<span className="hidden sm:inline">Contact me</span>
						</div>
					</a>
					<a
						href="https://drive.google.com/file/d/1SZfa6w20MSXsejCv8GyuUVjLL6ChucXy/view?usp=sharing"
						target="_blank"
						rel="noreferrer"
					>
						<div className="py-2 px-5 bg-blue-200 rounded-md text-primary font-medium w-full sm:max-w-[200px]">
							<Icon
								icon="mdi:link"
								className="text-2xl sm:hidden"
							/>
							<span className="hidden sm:inline">Hire Me</span>
						</div>
					</a>
				</div>
			</div>
		</section>
	);
}

export default Hero;
